export default __webpack_public_path__ + "static/media/latest-card-img-1.2e658f93.png";